import {http_client} from '@/plugins/http_client';

const getUnidadesOrganizativas = async (params) => await http_client('api/unidad', params, 'get');
const getEstructuraPlazas = async (params) => await http_client('api/v1/planilla/estructura-plaza', params, 'get');
const getDetallePlazas = async (params) => await http_client('api/v1/planilla/estructura-plaza/plaza', params, 'get');
//
const updateDetallePlaza = async (id_unidad_organizativa = 0, id_detalle_plaza = 0, body) =>
	await http_client(`api/v1/planilla/estructura-plaza/${id_unidad_organizativa}/${id_detalle_plaza} `, body, 'put');
//
const getDetallePlazasByPlaza = async (id_detalle_plaza = 0, params) =>
	await http_client(`api/v1/planilla/estructura-plaza/plaza/${id_detalle_plaza}`, params, 'get');
//
const getSubpartidasByPlazaAndUnidad = async (id_unidad_organizativa = 0, id_detalle_plaza = 0, params) =>
	await http_client(`api/v1/planilla/estructura-plaza/subpartida/${id_unidad_organizativa}/${id_detalle_plaza}`, params, 'get');
//
const getDetallePlazasSubpartida = async (params) =>
	await http_client(`/api/v1/planilla/estructura-plaza/disponibles`, params, 'get');
const SendCantidadSubpartida = async (id_detalle_plaza, params) =>
	await http_client(`/api/v1/planilla/estructura-plaza/subnumero/${id_detalle_plaza}`, params, 'post');
const detalleSubpartida = async (id_subpartida_unidad_organizativa, params) =>
	await http_client(`/api/v1/planilla/estructura-plaza/subnumero/${id_subpartida_unidad_organizativa}`, params, 'get');

// Catalogo de plazas
const getPlazas = async (params={}) => await http_client('api/v1/mantenimiento-plazas', params, 'get');
const getCategoriasPlazas = async () => await http_client('api/v1/mantenimiento-categorias/categorias-activas', {}, 'get');
const createPlaza = async (body) => await http_client('api/v1/mantenimiento-plazas', body, 'post');
const updatePlaza = async (id_plaza, body) => await http_client(`api/v1/mantenimiento-plazas/${id_plaza}`, body, 'put');
const changeStatusPlaza = async (id_plaza, body) => await http_client(`api/v1/mantenimiento-plazas/${id_plaza}/cambiar-estado`, body, 'patch');
const downloadPlanilla = async () => await http_client('api/v1/mantenimiento-plazas/descargar-plantilla', {}, 'get', {}, true, 'blob');
const uploadPlazas = async (body) =>
	await http_client('api/v1/mantenimiento-plazas/cargar-plazas', body, 'post', {
		headers: { 'content-type': 'multipart/form-data' },
	});
const getEstadoCarga = async (id) =>
	await http_client(`api/v1/mantenimiento-plazas/estado-carga/${id}`, {}, 'get');

export default {
	getUnidadesOrganizativas,
	getEstructuraPlazas,
	getDetallePlazas,
	updateDetallePlaza,
	getDetallePlazasByPlaza,
	getSubpartidasByPlazaAndUnidad,
	getDetallePlazasSubpartida,
	SendCantidadSubpartida,
	detalleSubpartida,

	// Catalogo de plazas
	getPlazas,
	getCategoriasPlazas,
	createPlaza,
	updatePlaza,
	changeStatusPlaza,
	downloadPlanilla,
	uploadPlazas,
	getEstadoCarga,
};
